<ng-container *ngIf="label || icon">
    <div class="ds-badge" [ngClass]="badgeClasses">
        <ng-container *ngIf="icon">
            <mat-icon [fontSet]="iconFontSet" [ngStyle]="{ fontSize: iconSize, width: iconSize, height: iconSize }">{{ icon }}</mat-icon>
        </ng-container>

        <ng-container *ngIf="label">
            <span>{{ label }}</span>
        </ng-container>
    </div>
</ng-container>
